import { Directive, ElementRef, AfterViewInit, Input, OnDestroy, NgZone } from '@angular/core';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';

import { CustomLocation } from '../services/location.custom';

interface ScrollerOptions {
	restoreAfterViewInit: boolean;
	storeName: string;
}

interface ScrollState {
	scrollTop: number;
}

@Directive({
	selector: '[copoScroller]',
	exportAs: 'copoScroller',
})
export class ScrollerDirective extends CdkScrollable implements AfterViewInit, OnDestroy {
	@Input() copoScroller?: Partial<ScrollerOptions>;
	stateId: number;

	constructor(
		elementRef: ElementRef<HTMLElement>,
		scrollDispatcher: ScrollDispatcher,
		ngZone: NgZone
	) {
		super(elementRef, scrollDispatcher, ngZone);
		this.stateId = CustomLocation.GET_CURRENT_STATE_ID();
	}

	getOptions() {
		return {
			restoreAfterViewInit: true,
			storeName: 'copoScrollState',
			...this.copoScroller
		};
	}

	ngAfterViewInit() {
		if (this.getOptions().restoreAfterViewInit) {
			this.restoreState();
		}
	}

	saveState() {
		const scrollState: ScrollState = { scrollTop: this.elementRef.nativeElement.scrollTop };
		CustomLocation.SET_STATE(this.getOptions().storeName, this.stateId, scrollState);
	}

	restoreState() {
		const scrollState = <ScrollState | null> CustomLocation.GET_STATE(this.getOptions().storeName, this.stateId);
		if (scrollState) {
			this.setScrollTop(scrollState.scrollTop);
		}
	}

	setScrollTop(scrollTop: number) {
		const el = this.elementRef.nativeElement;
		if (el.scrollTop === scrollTop) {
			return;
		}
		const { style, style: { scrollBehavior } } = el;
		style.scrollBehavior = 'auto';
		el.scrollTop = scrollTop;
		style.scrollBehavior = scrollBehavior;
	}

	override ngOnDestroy() {
		super.ngOnDestroy();
		this.saveState();
	}
}
